<div class="header">
  <div class="start"></div>
  <div class="title">Thank you for choosing Assura+Protect as your preferred insurance partner!</div>
  <div class="end"></div>
</div>

<div class="apg-panel">
  <app-site-content key="FullQuote.Complete"></app-site-content>
</div>